export const PhoneRegex = /^ *(\d{10}|\d{3}-\d{3}-\d{4}|\(\d{3}\) *\d{3}-\d{4}) *$/;

// https://html.spec.whatwg.org/multipage/input.html#the-pattern-attribute
// https://stackoverflow.com/questions/50042768/email-validation-passes-without-domain-extension
export const EmailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
export const AdminEmailRegex = /^(['_a-zA-Z0-9-&]+)(\.['_a-zA-Z0-9-&]+)*@([a-zA-Z0-9-]+)(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,3})$/;


export const roleNameRegex = /^(?![0-9]*$)[ a-zA-Z0-9]+$/;

export const firstNameRegex = /^['a-z'A-Z'-\s]{1,50}$/;

export const lastNameRegex = /^[A-Za-z'-\s]{1,50}$/;

export const positionRegex = /^[ A-Za-z0-9_@./#&+-]*$/

export const BlankOrDangerousRegex = /(\beval\b|^\s*$)/;

export const DangerousRegex = /\beval\b/;

export const addressRegex = /^[#.'0-9a-zA-Z\s,-]+$/;

// export const cityRegex = /^[a-zA-Z]/;/**It should start with numarical */
export const cityRegex = /^[a-zA-Z][a-zA-Z0-9#,'. ]*$/;/**It should start with numarical */

export const zipcodeRegex = /^[0-9-a-zA-Z]*$/;

export const alphaRegex = /^[A-Za-z]+$/;

export const alphaNumericWithPeriodRegex = /[A-z._\-]+/;

export const alphaNumericWithSpaceRegex = /^[ A-Za-z0-9_@'./#&+-]*$/;

export const workflowRegex = /^[ A-Za-z0-9<>,!@#$%^&*()'.]*$/;

export const ManufactureNameRegex = /^[ A-Za-z0-9@./#&\-']*$/;

// export const alphaNumericWithSpaceRegex = /^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9 @&$]*)?$/;
export const alphaNumericWithSpaceRegex1 = /^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9]*)?$/;

export const NumericWithPercentageRegex = /\d+(\%)/g;

export const MatchLastLetterIndiviual = /^[a-z|A-Z|0-9]+[^I]\s?I{1}$/;

export const DateRegex = /^\d{2}\/\d{2}\/\d{4}$/;

export const numberWithDecimalOnlyRegex = /^\d+(\.\d{1,8})?$/;

export const NumberRegex = /^[0-9]*$/;

export const DecimalRegex = /^\d{1,2}(\.\d{1,8})?$/;

//export const EntityBusinessNameRegex = /^[a-zA-Z0-9!#'&,\-@()]+[!#'&,\-@()a-zA-Z0-9\s]+[a-zA-Z0-9]+[a-zA-Z0-9!#'&,\-@()\s]*$/;
export const EntityBusinessNameRegex = /^[a-zA-Z0-9!,\.\\#'&@\-\[\]\(\)+%$\?\>\<\/ ]*[a-zA-Z0-9]+[a-zA-Z0-9!,\.\\#'&@\-\[\]\(\)+%$\?\>\<\/ ]*$/;//LOSF-4787, LOSF-13397

export const DecimalRegexWithPercentage = /^\d{1,2}(\.\d{1,8})?%$/;

export const fileNameRegex = /^[ A-Za-z0-9_&\-().,]*$/;

export const alphaNumericWithSpaceRegexForDebtSchedule = /^[a-z\d\-_\s]+$/i ;

export const negativeDecimalRegex = /^-?[0-9]\d*(\.\d+)?$/;

export const alphaWithSpaceRegex = /^[A-Za-z ]+$/;

export const alphaNumericWithSpaceRegexForCovenantValue = /^[0-9A-Za-z._\-\/ ]+$/;

export const aggregatedPeriodNameRegex = /^[a-zA-Z0-9!,\.\\#:;^*|{}"+=_'&@\-\[\]\(\)+%$\?\>\<\/ ]*[a-zA-Z0-9]+[a-zA-Z0-9!,\.\\#:;^*|{}"+=_'&@\-\[\]\(\)+%$\?\>\<\/ ]*$/;

export const spreadCustomRatioRegex = /^[a-zA-Z0-9!,\.\\#:;^*~`|{}"+=_'&@\-\[\]\(\)+%$\?\>\<\/ ]*[a-zA-Z0-9]+[a-zA-Z0-9!,\.\\#:;^*~`|{}"+=_'&@\-\[\]\(\)+%$\?\>\<\/ ]*$/;
